export default __webpack_public_path__ + "static/media/dating4.f7708786.png";